import React, { useState } from 'react'
import styled from 'styled-components'

type IconLinkProps = {
    icon: string
    target: string
    links: {
        icon: string
        icon_inverted: string
        icon_inverted_hover: string
        icon_hover: string
    }

    inverted: boolean
}

const IconLink: React.FunctionComponent<IconLinkProps> = ({  target, inverted, links }) => {
    const [hover, setHover] = useState(false)

    // @ts-ignore
    const name = getIcon(inverted, hover)
    // @ts-ignore
    const path = links[name]

    return (
        <Link 
            target='_blank' 
            href={target} 
            onMouseEnter={() => setHover(true)} 
            onMouseLeave={() => setHover(false)} 
            onTouchStart={() => setHover(true)}
            onTouchEnd={() => setHover(false)}
        >
            <Icon src={path} />
        </Link>
    )
}

const getIcon = (inverted: boolean, hover: boolean) => {
    // Construct path, it could be icon, icon_inverted, icon_hover or icon_inverted_hover
    const parts = ['icon']
    if (inverted) {
        parts.push('inverted')
    }

    if (hover) {
        parts.push('hover')
    }

    return parts.join('_')
}

const Link = styled.a`

`

const Icon = styled.img`

`

export default IconLink